import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Row, Col } from 'react-bootstrap';
import { OutboundLink } from 'gatsby-plugin-google-analytics';

import './TechCard.scss';

const TechCard = ({ iconClass, text, smallText, onCardClick, href }) => {
    const classList = {
        icon: true,
    };
    classList[iconClass] = true;

    const textElement = (<p>
        {text}
    </p>);
    const smallTextElement = (smallText) ? (<p>
        <small>
            {smallText}
        </small>
    </p>) : null;

    const onClick = (event) => {
        if (!onCardClick) {
            return;
        }

        event.preventDefault();
        onCardClick(event.currentTarget.getElementsByTagName('a')[0].href);
    };

    return (
        <div className='techCardBox' onClick={onClick}>
            <OutboundLink
                className='techCard'
                href={href}
            >
                <Row className="align-items-center">
                    <Col className="d-flex align-items-center">
                        <i className={classNames(classList)}/>
                        <div>
                            {textElement}
                            {smallTextElement}
                        </div>
                    </Col>
                </Row>
            </OutboundLink>
        </div>
    );
};

TechCard.propTypes = {
    href: PropTypes.string.isRequired,
    iconClass: PropTypes.string.isRequired,
    onCardClick: PropTypes.func,
    smallText: PropTypes.string,
    text: PropTypes.string.isRequired,
};

export default TechCard;
